// extracted by mini-css-extract-plugin
module.exports = {"colSlider":"S_b9","arrowsContainer":"S_cb","arrowBtn":"S_cc","fullScreen":"S_cd"};